<template>
    <div class="mb-5">
        <div v-if="loader" id="loader"></div>
        <div class="sticky-col">
            <div>
                <nav>
                    <div class="nav nav-tabs tabs-menu w-tab-menu" :id="'nav-tab-'+form.parentId" role="tablist">
                        <template v-for="(element, idx) in blocks">
                            <a @click="changeTab(element.order)" class="nav-item nav-link pointer"
                               :class="{ active: idx==0 }" :id="'nav-'+element.id+'-tab-'+form.parentId"
                               data-toggle="tab" :data-target="'#nav-'+form.parentId+'-'+element.id" role="tab"
                               aria-controls="nav-home" aria-selected="true">
                                <div class="hover-image d-flex justify-content-center">
                                    <div class="content-icon-wrap block-category-icons">
                                        <img width="30" loading="lazy" style="opacity: 1;"
                                             class="inactive-icon block-category-icons"
                                             :src="'/images/block-type-icons/'+element.icon">
                                        <img width="30" loading="lazy" style="opacity: 0;"
                                             class="active-icon block-category-icons"
                                             :src="'/images/block-type-icons/' + element.icon.split('.')[0] + '-active.' + element.icon.split('.')[1]">
                                    </div>
                                    <div class="d-flex align-items-center">
                                        {{ trans('course.creator.elements.' + element.name) }}
                                    </div>
                                </div>
                            </a>
                        </template>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                    <template v-for="(element, idx) in blocks">
                        <div class="tab-pane fade" :class="{show : idx==0, active : idx==0}"
                             :id="'nav-'+form.parentId+'-'+element.id" role="tabpanel"
                             :aria-labelledby="'nav-'+element.id+'-tab'" :key="element.id">
                            <draggable
                                :clone="cloneBlock"
                                tag="div"
                                :group="{ name: 'blocks',
                                pull: 'clone',
                                put: false }"
                                :list="blocks[form.blockTab-1].blocks"
                                class="mt-2 mb-2 pl-2 pr-2">
                                <div v-for="(block, idcx) in element.blocks" class="d-inline-block mr-3">
                                    <div class="content-icon-wrap hover-image block-icon-wrap">
                                        <img loading="lazy" style="opacity: 1;" class="editor-block-image inactive-icon"
                                             :src="'/images/block-icons/'+block.icon">
                                        <img data-toggle="tooltip" data-placement="top" :title="block.name"
                                             loading="lazy" style="opacity: 0;" class="editor-block-image active-icon"
                                             :src="'/images/block-icons/' + block.icon.split('.')[0] + '-active.' + block.icon.split('.')[1]">
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <draggable handle=".handle"
                   @change="change()"
                   :swapThreshold="0.5"
                   :scroll="true"
                   :scroll-speed="2000"
                   :scroll-sensitivity="10"
                   tag="div"
                   group="blocks"
                   :list="form.blocksData"
                   class="course-section-area mt-0 content-section-area"
                   :class="!form.blocksData.length ? 'empty-section-area' : '' " v-click-outside="closeEvent">
            <!--  <div v-if="!form.blocksData.length" class="block-placeholder">
                 <div class="title">Drop block here</div>
             </div> -->
            <div v-for="(element, idx) in form.blocksData" :key="element.id+idx" class="editor-workspace">
                <div v-if="form.blocksData[idx].deleted" class="removed-content text-center">
                    <div class="remove-restore-content-container">
                    <h5 class="">{{ trans('course.add_course_content_removed_msg') }}</h5>
                    <div class="delete-restore-button-container">
                    <button @click="restoreBlock(idx)" class="btn btn-success delete-restore-buttons">
                        {{ trans('course.add_course_restore') }}
                    </button>
                    <button type="button" @click="deletePermanently(idx)" class="btn btn-danger delete-restore-buttons">
                        {{ trans('course.add_course_delete_permanently') }}
                    </button>
                    </div>
                    </div>
                </div>
                <template v-else>
                    <button @click="removeBlock(idx, $event)"
                            :data-confirm-title="trans('messages.remove_element_confirm_dialog_title')"
                            :data-confirm-message="trans('messages.remove_element_confirm_dialog_message')"
                            type="button"
                            class="close mt-1"
                            aria-label="Close">
                        <span aria-hidden="true"><img width="20"
                                                      :src="'/images/marLMS-delete-without-frame.png'"
                        style="position: relative; margin-left: 0.2rem"></span>
                    </button>
                    <div v-if="form.blocksData[idx].error" class="alert alert-danger alert-dismissible fade show"
                         role="alert">
                        {{ form.blocksData[idx].error }}
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <template v-if="[1,2].includes(element.type)">
                        <div class="row">
                            <div class="col-12 p-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 3">
                        <div class="row">
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                   v-html="form.blocksData[idx].col1 || placeholder"></p>
                            </div>
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                   v-html="form.blocksData[idx].col2 || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 4">
                        <div class="row">
                            <div class="col-4 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                   v-html="form.blocksData[idx].col1 || placeholder"></p>
                            </div>
                            <div class="col-4 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                   v-html="form.blocksData[idx].col2 || placeholder"></p>
                            </div>
                            <div class="col-4 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].col3" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col3}"
                                   v-html="form.blocksData[idx].col3 || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="[5,26].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <div class="col-12 pl-0">
                                <template v-if="!form.blocksData[idx].resize">
                                    <img class="w-100" :src="form.blocksData[idx].image+'?token='+token">
                                    <button @click="uploadTrigger(idx)" type="button" class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}

                                    </button>
                                    <button @click="choseFromLibrary(idx, 'images', 'image')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <button type="button" @click="showResizeImage(idx)"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-crop"></i>
                                        {{ trans('course.add_course_resize') }}
                                    </button>
                                    <button v-if="!isDefaultImage(form.blocksData[idx].image)" type="button"
                                            @click.prevent="copyMediaReferenceToClipboard(form.blocksData[idx].image)"
                                            class="image-upload-editor mt-2 mb-2"
                                    >
                                        <i class="fas fa-clipboard"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <cropper
                                        class="cropper"
                                        :src="form.blocksData[idx].image+'?token='+token"
                                        :ref="'cropper'+idx"
                                    ></cropper>
                                    <button class="image-upload-editor mt-2 mb-2" type="button" @click="uploadImage(idx)">
                                        <i class="fas fa-save"></i>
                                        Crop
                                    </button>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="getOriginalImage(idx)">
                                        <i class="fas fa-undo"></i>
                                        {{ trans('course.add_course_restore_image') }}
                                    </button>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom Out"
                                       @click="imageZoom(idx,'minus')" class="fas fa-search-minus pointer ml-2"></i>
                                    <label>{{ trans('course.add_course_zoom') }}</label>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom In"
                                       @click="imageZoom(idx,'plus')" class="fas fa-search-plus pointer"></i>
                                </template>
                                <input @change="uploadFile($event, idx, false, 'image')" type="file" accept="image/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                                <template v-if="element.type == 26">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="[6,27].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0">
                                <template v-if="!form.blocksData[idx].resize1">
                                    <img class="w-100" :src="form.blocksData[idx].image1+'?token='+token">
                                    <button @click="uploadTrigger(idx, 'col1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'images', 'image1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <button type="button" @click="showResizeImage(idx,'1')"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-crop"></i>
                                        {{ trans('course.add_course_resize') }}
                                    </button>
                                    <button v-if="!isDefaultImage(form.blocksData[idx].image1)" type="button"
                                            @click.prevent="copyMediaReferenceToClipboard(form.blocksData[idx].image1)"
                                            class="image-upload-editor mt-2 mb-2"
                                    >
                                        <i class="fas fa-clipboard"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <cropper
                                        class="cropper"
                                        :src="form.blocksData[idx].image1+'?token='+token"
                                        :ref="'cropper-image1-'+idx"
                                    ></cropper>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="uploadImage(idx,1)">
                                        <i class="fas fa-save"></i>
                                        {{ trans('course.add_course_crop') }}
                                    </button>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="getOriginalImage(idx,1)">
                                        <i class="fas fa-undo"></i>
                                        {{ trans('course.add_course_restore_image') }}
                                    </button>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom Out"
                                       @click="imageZoom(idx,'minus',1)" class="fas fa-search-minus pointer ml-2"></i>
                                    <label>{{ trans('course.add_course_zoom') }}</label>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom In"
                                       @click="imageZoom(idx,'plus',1)" class="fas fa-search-plus pointer"></i>
                                </template>
                                <input @change="uploadFile($event, idx, 1,'image')" type="file" accept="image/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-col1-'+idx">
                                <template v-if="element.type == 27">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                       v-html="form.blocksData[idx].col1 || placeholder"></p>
                                </template>
                            </div>
                            <div class="col-6 pr-0">
                                <template v-if="!form.blocksData[idx].resize2">
                                    <img class="w-100" :src="form.blocksData[idx].image2+'?token='+token">
                                    <button @click="uploadTrigger(idx, 'col2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'images', 'image2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <button type="button" @click="showResizeImage(idx,'2')"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-crop"></i>
                                        {{ trans('course.add_course_resize') }}
                                    </button>
                                    <button v-if="!isDefaultImage(form.blocksData[idx].image2)" type="button"
                                            @click.prevent="copyMediaReferenceToClipboard(form.blocksData[idx].image2)"
                                            class="image-upload-editor mt-2 mb-2"
                                    >
                                        <i class="fas fa-clipboard"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <cropper
                                        class="cropper"
                                        :src="form.blocksData[idx].image2+'?token='+token"
                                        :ref="'cropper-image2-'+idx"
                                    ></cropper>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="uploadImage(idx,2)">
                                        <i class="fas fa-save"></i>
                                        {{ trans('course.add_course_crop') }}
                                    </button>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="getOriginalImage(idx,2)">
                                        <i class="fas fa-undo"></i>
                                        {{ trans('course.add_course_restore_image') }}
                                    </button>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom Out"
                                       @click="imageZoom(idx,'minus',2)" class="fas fa-search-minus pointer ml-2"></i>
                                    <label>{{ trans('course.add_course_zoom') }}</label>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom In"
                                       @click="imageZoom(idx,'plus',2)" class="fas fa-search-plus pointer"></i>
                                </template>
                                <input @change="uploadFile($event, idx, 2, 'image')" type="file" accept="image/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-col2-'+idx">
                                <template v-if="element.type == 27">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                       v-html="form.blocksData[idx].col2 || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 7">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0 pr-0">
                                <template v-if="!form.blocksData[idx].resize">
                                    <img class="w-100" :src="form.blocksData[idx].image+'?token='+token">
                                    <button @click="uploadTrigger(idx)" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'images', 'image')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <button type="button" @click="showResizeImage(idx)"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-crop"></i>
                                        {{ trans('course.add_course_resize') }}
                                    </button>
                                    <button v-if="!isDefaultImage(form.blocksData[idx].image)" type="button"
                                            @click.prevent="copyMediaReferenceToClipboard(form.blocksData[idx].image)"
                                            class="image-upload-editor mt-2 mb-2"
                                    >
                                        <i class="fas fa-clipboard"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <cropper
                                        class="cropper"
                                        :src="form.blocksData[idx].image+'?token='+token"
                                        :ref="'cropper'+idx"
                                    ></cropper>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="uploadImage(idx)">
                                        <i class="fas fa-save"></i>
                                        {{ trans('course.add_course_crop') }}
                                    </button>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="getOriginalImage(idx)">
                                        <i class="fas fa-undo"></i>
                                        {{ trans('course.add_course_restore_image') }}
                                    </button>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom Out"
                                       @click="imageZoom(idx,'minus')" class="fas fa-search-minus pointer ml-2"></i>
                                    <label>{{ trans('course.add_course_zoom') }}</label>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom In"
                                       @click="imageZoom(idx,'plus')" class="fas fa-search-plus pointer"></i>
                                </template>
                                <input @change="uploadFile($event, idx, false, 'image')" type="file" accept="image/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                            </div>
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 8">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                            <div class="col-6 pl-0 pr-0">
                                <template v-if="!form.blocksData[idx].resize">
                                    <img class="w-100" :src="form.blocksData[idx].image+'?token='+token">
                                    <button @click="uploadTrigger(idx)" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'images', 'image')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <button type="button" @click="showResizeImage(idx)"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-crop"></i>
                                        {{ trans('course.add_course_resize') }}
                                    </button>
                                    <button v-if="!isDefaultImage(form.blocksData[idx].image)" type="button"
                                            @click.prevent="copyMediaReferenceToClipboard(form.blocksData[idx].image)"
                                            class="image-upload-editor mt-2 mb-2"
                                    >
                                        <i class="fas fa-clipboard"></i>
                                    </button>
                                </template>
                                <template v-else>
                                    <cropper
                                        class="cropper"
                                        :src="form.blocksData[idx].image+'?token='+token"
                                        :ref="'cropper'+idx"
                                    ></cropper>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="uploadImage(idx)">
                                        <i class="fas fa-save"></i>
                                        {{ trans('course.add_course_crop') }}
                                    </button>
                                    <button class="image-upload-editor mt-2 mb-2" type="button"
                                            @click="getOriginalImage(idx)">
                                        <i class="fas fa-undo"></i>
                                        {{ trans('course.add_course_restore_image') }}
                                    </button>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom Out"
                                       @click="imageZoom(idx,'minus')" class="fas fa-search-minus pointer ml-2"></i>
                                    <label>{{ trans('course.add_course_zoom') }}</label>
                                    <i data-toggle="tooltip" data-placement="top" title="Zoom In"
                                       @click="imageZoom(idx,'plus')" class="fas fa-search-plus pointer"></i>
                                </template>


                                <input @change="uploadFile($event, idx, false, 'image')" type="file" accept="image/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 9">
                        <div class="row mt-2 mb-2">
                            <video-embed v-if="form.blocksData[idx].externalVideo"
                                         :src="form.blocksData[idx].externalVideoUrl"></video-embed>
                            <img v-else-if="form.blocksData[idx].video
                                        && form.blocksData[idx].video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                            <video v-else class="w-100" controls :key="idx+Math.random()">
                                <source :src="form.blocksData[idx].video+'?token='+token" type="video/mp4">
                            </video>
                            <template v-if="form.blocksData[idx].showExternalVideoInput">

                                <div class="col-12">
                                     <label>{{ trans('course.add_course_paste_link_here') }}</label>

                                     <div class="col">
                                    <div class="col-12 col-lg-6">
                                        <input v-model="form.blocksData[idx].externalVideoUrl" type="text"
                                               class="form-control">
                                    </div>
                                    <div class="col-12 col-lg-6">
                                        <button type="button" @click="addExternalVideo(idx)"
                                                class="btn btn-success w-100">{{ trans('course.add_course_add') }}
                                        </button>
                                    </div>
                                    </div>
                                </div>
                            </template>
                            <button @click="uploadTrigger(idx)" type="button" class="image-upload-editor mt-2 mb-2">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_upload_from_pc') }}
                            </button>
                            <button @click="choseFromLibrary(idx, 'videos', 'video')" type="button"
                                    class="image-upload-editor mt-2 mb-2">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_chose_from_library') }}
                            </button>
                            <button @click="showExternalVideo(idx,'showExternalVideoInput')" type="button"
                                    class="image-upload-editor mt-2 mb-2">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_upload_external_video') }}
                            </button>
                            <input @change="uploadFile($event, idx, false, 'video')" type="file" accept="video/*"
                                   style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                        </div>
                    </template>
                    <template v-if="element.type == 10">
                        <div class="row mt-2 mb-2">
                            <video-embed v-if="form.blocksData[idx].externalVideo"
                                         :src="form.blocksData[idx].externalVideoUrl"></video-embed>
                            <img v-else-if="form.blocksData[idx].video
                                        && form.blocksData[idx].video.substr(0, 18) === '/video/preview.mp4'" src="/images/video-placeholder.svg">
                            <video v-else class="w-100" controls :key="idx+Math.random()">
                                <source :src="form.blocksData[idx].video+'?token='+token" type="video/mp4">
                            </video>
                            <template v-if="form.blocksData[idx].showExternalVideoInput">

                                <div class="col-12">
                                      <label>{{ trans('course.add_course_paste_link_here') }}</label>

                                      <div class="row">
                                    <div class="col-12  col-xl-8">
                                        <input v-model="form.blocksData[idx].externalVideoUrl" type="text"
                                               class="form-control special-upload-input">
                                    </div>
                                    <div class="col-12 col-xl-4 mt-2 mt-xl-0">
                                        <button type="button" @click="addExternalVideo(idx)"
                                                class="btn btn-success w-100 link-upload-button">{{ trans('course.add_course_add') }}
                                        </button>
                                    </div>
                                    </div>
                                </div>
                            </template>
                            <div class="col-12 mt-2 single-line-button-container">
                            <button @click="uploadTrigger(idx)" type="button" class="image-upload-editor single-line-button">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_upload_from_pc') }}
                            </button>
                            <button @click="choseFromLibrary(idx, 'videos', 'video')" type="button"
                                    class="image-upload-editor single-line-button">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_chose_from_library') }}
                            </button>
                            <button @click="showExternalVideo(idx, 'showExternalVideoInput')" type="button"
                                    class="image-upload-editor single-line-button">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_upload_external_video') }}
                            </button>
                            </div>
                            <input @change="uploadFile($event, idx, false, 'video')" type="file" accept="video/mp4"
                                   style="display:none" name="" :id="'file-input-'+unique+'-'+idx">

                            <div class="col-12">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 11">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0 pr-0">
                                <video-embed v-if="form.blocksData[idx].externalVideo"
                                             :src="form.blocksData[idx].externalVideoUrl"></video-embed>
                                <img v-else-if="form.blocksData[idx].video
                                        && form.blocksData[idx].video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100" controls :key="idx+Math.random()">
                                    <source :src="form.blocksData[idx].video+'?token='+token" type="video/mp4">
                                </video>
                                <template v-if="form.blocksData[idx].showExternalVideoInput">
                                    <label>{{ trans('course.add_course_paste_link_here') }}</label>
                                    <div class="row">
                                        <div class="col-12 col-xl-8 ">
                                            <input v-model="form.blocksData[idx].externalVideoUrl" type="text"
                                                   class="form-control link-upload-input">
                                        </div>
                                        <div class="col-12 mt-2 mt-xl-0 col-xl-4">
                                            <button type="button" @click="addExternalVideo(idx)"
                                                    class="btn btn-success w-100 link-upload-button">{{ trans('course.add_course_add') }}
                                            </button>
                                        </div>
                                    </div>
                                </template>
                                <button @click="uploadTrigger(idx)" type="button" class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="choseFromLibrary(idx, 'videos', 'video')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>
                                <button @click="showExternalVideo(idx,'showExternalVideoInput')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_external_video') }}
                                </button>
                                <input @change="uploadFile($event, idx, false, 'video')" type="file" accept="video/mp4"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                            </div>
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                        </div>
                    </template>
                    <template v-if="element.type == 12">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0 pr-0">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </div>
                            <div class="col-6 pl-0 pr-0">
                                <video-embed v-if="form.blocksData[idx].externalVideo"
                                             :src="form.blocksData[idx].externalVideoUrl"></video-embed>
                                <img v-else-if="form.blocksData[idx].video
                                        && form.blocksData[idx].video.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100" controls :key="idx+Math.random()">
                                    <source :src="form.blocksData[idx].video+'?token='+token" type="video/mp4">
                                </video>
                                <template v-if="form.blocksData[idx].showExternalVideoInput">
                                    <label>{{ trans('course.add_course_paste_link_here') }}</label>
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <input v-model="form.blocksData[idx].externalVideoUrl" type="text"
                                                   class="form-control link-upload-input">
                                        </div>
                                        <div class="col-12 mt-2 col-xl-4 mt-xl-0">
                                            <button type="button" @click="addExternalVideo(idx)"
                                                    class="btn btn-success w-100 link-upload-button">{{ trans('course.add_course_add') }}
                                            </button>
                                        </div>
                                    </div>
                                </template>
                                <button @click="uploadTrigger(idx)" type="button" class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="choseFromLibrary(idx, 'videos', 'video')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>
                                <button @click="showExternalVideo(idx,'showExternalVideoInput')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_external_video') }}
                                </button>
                                <input @change="uploadFile($event, idx, false, 'video')" type="file" accept="video/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                            </div>
                        </div>
                    </template>
                    <template v-if="[13,18].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <div class="col-12 p-0">
                                <img v-if="form.blocksData[idx].audio
                                        && form.blocksData[idx].audio.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                <audio v-else class="w-100" controls :src="form.blocksData[idx].audio"></audio>
                                <button @click="uploadTrigger(idx)" type="button" class="image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="choseFromLibrary(idx, 'audio', 'audio')" type="button"
                                        class="image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>

                                <input @change="uploadFile($event, idx, false,'audio')" type="file" accept="audio/*"
                                       style="display:none" name="" :id="'file-input-'+unique+'-'+idx">
                                <template v-if="element.type == 18">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="[14,20].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <button @click="uploadTrigger(idx)" type="button" class="image-upload-editor mt-2 mb-2">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_upload_from_pc') }}
                            </button>
                            <button @click="choseFromLibrary(idx, 'documents', 'document')" type="button"
                                    class="image-upload-editor mt-2 mb-2">
                                <i class="fas fa-upload"></i>
                                {{ trans('course.add_course_chose_from_library') }}
                            </button>
                            <iframe v-if="form.blocksData[idx].format == 'document'" class="iframe-editor"
                                    :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+form.blocksData[idx].document+'?token='+token"
                                    width='100%' height='100%' frameborder='0'></iframe>
                            <iframe v-if="form.blocksData[idx].format == 'pdf'" class="iframe-editor"
                                    :src="form.blocksData[idx].document+'?token='+token" width='100%' height='100%'
                                    frameborder='0'></iframe>

                            <input @change="uploadFile($event, idx, false, 'document')" type="file"
                                   accept=".pdf,.doc,.docx,.pptx,.pptm,.xlsx,.xls" style="display:none" name=""
                                   :id="'file-input-'+unique+'-'+idx">
                            <template v-if="element.type == 20">
                                <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                          v-if="form.blocksData[idx].showEditorBlock"
                                          v-model="form.blocksData[idx].content" @blur="onEditorBlur" :editor="editor"
                                          :config="textEditorConfig"></null-safe-ck-editor>
                                <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                   :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                   v-html="form.blocksData[idx].content || placeholder"></p>
                            </template>
                        </div>
                    </template>
                    <template v-if="element.type == 15">
                        <div class="row mt-2 mb-2">
                            <img @click="keepClick(form.blocksData, idx)" data-toggle="tooltip" data-placement="top"
                                 title="Keep" class="pointer keep-image next-link" :src="'/images/KeeP Button.png'">
                        </div>
                    </template>
                    <template v-if="[16,17].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0">
                                <video-embed v-if="form.blocksData[idx].externalVideo1"
                                             :src="form.blocksData[idx].externalVideoUrl1"></video-embed>
                                <img v-else-if="form.blocksData[idx].video1
                                        && form.blocksData[idx].video1.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100" controls :key="idx+Math.random()">
                                    <source :src="form.blocksData[idx].video1+'?token='+token" type="video/mp4">
                                </video>
                                <template v-if="form.blocksData[idx].showExternalVideoInput1">
                                    <label>{{ trans('course.add_course_paste_link_here') }}</label>
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <input v-model="form.blocksData[idx].externalVideoUrl1" type="text"
                                                   class="form-control link-upload-input">
                                        </div>
                                        <div class="col-12 mt-2 col-xl-4 mt-xl-0">
                                            <button type="button" @click="addExternalVideo(idx,'1')"
                                                    class="btn btn-success w-100 link-upload-button">{{ trans('course.add_course_add') }}
                                            </button>
                                        </div>
                                    </div>
                                </template>
                                <button @click="uploadTrigger(idx, 'video1')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="choseFromLibrary(idx, 'videos', 'video1')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>
                                <button @click="showExternalVideo(idx,'showExternalVideoInput1')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_external_video') }}
                                </button>
                                <input @change="uploadFile($event, idx, 1,'video')" type="file" accept="video/mp4"
                                       style="display:none" name="" :id="'file-input-'+unique+'-video1-'+idx">
                                <template v-if="element.type == 17">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                       v-html="form.blocksData[idx].col1 || placeholder"></p>
                                </template>
                            </div>
                            <div class="col-6 pr-0">
                                <video-embed v-if="form.blocksData[idx].externalVideo2"
                                             :src="form.blocksData[idx].externalVideoUrl2"></video-embed>
                                <img v-else-if="form.blocksData[idx].video2
                                        && form.blocksData[idx].video2.substr(0, 18)=== '/video/preview.mp4'" src="/images/video-placeholder.svg">
                                <video v-else class="w-100" controls :key="idx+Math.random()">
                                    <source :src="form.blocksData[idx].video2+'?token='+token" type="video/mp4">
                                </video>
                                <template v-if="form.blocksData[idx].showExternalVideoInput2">
                                    <label>{{ trans('course.add_course_paste_link_here') }}</label>
                                    <div class="row">
                                        <div class="col-12 col-xl-8">
                                            <input v-model="form.blocksData[idx].externalVideoUrl2" type="text"
                                                   class="form-control link-upload-input">
                                        </div>
                                        <div class="col-12 mt-2 col-xl-4 mt-xl-0">
                                            <button type="button" @click="addExternalVideo(idx,'2')"
                                                    class="btn btn-success w-100 link-upload-button ">{{ trans('course.add_course_add') }}
                                            </button>
                                        </div>
                                    </div>
                                </template>
                                <button @click="uploadTrigger(idx, 'video2')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_from_pc') }}
                                </button>
                                <button @click="choseFromLibrary(idx, 'videos', 'video2')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_chose_from_library') }}
                                </button>
                                <button @click="showExternalVideo(idx,'showExternalVideoInput2')" type="button"
                                        class="col-12 col-xl-8 image-upload-editor mt-2 mb-2">
                                    <i class="fas fa-upload"></i>
                                    {{ trans('course.add_course_upload_external_video') }}
                                </button>
                                <input @change="uploadFile($event, idx, 2, 'video')" type="file" accept="video/mp4"
                                       style="display:none" name="" :id="'file-input-'+unique+'-video2-'+idx">
                                <template v-if="element.type == 17">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                       v-html="form.blocksData[idx].col2 || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="[19,28, 29, 30].includes(element.type)">
                        <div class="row mt-2 mb-2">
                            <div class="col-6 pl-0">
                                <template v-if="[19,28, 29].includes(element.type)">
                                    <img v-if="form.blocksData[idx].audio1
                                        && form.blocksData[idx].audio1.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                    <audio v-else class="w-100" controls :src="form.blocksData[idx].audio1"></audio>
                                    <button @click="uploadTrigger(idx, 'audio1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'audio', 'audio1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <input @change="uploadFile($event, idx, 1,'audio')" type="file" accept="audio/*"
                                           style="display:none" name="" :id="'file-input-'+unique+'-audio1-'+idx">
                                </template>
                                <template v-if="[30].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                                <template v-if="[28].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                       v-html="form.blocksData[idx].col1 || placeholder"></p>
                                </template>
                            </div>
                            <div class="col-6 pr-0">
                                <template v-if="[19,28,30].includes(element.type)">
                                    <img v-if="form.blocksData[idx].audio2
                                        && form.blocksData[idx].audio2.substr(0, 16)=== '/audio/audio.mp3'" src="/images/audio-placeholder.svg">
                                    <audio v-else class="w-100" controls :src="form.blocksData[idx].audio2"></audio>
                                    <button @click="uploadTrigger(idx,'audio2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'audio', 'audio2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <input @change="uploadFile($event, idx, 2,'audio')" type="file" accept="audio/*"
                                           style="display:none" name="" :id="'file-input-'+unique+'-audio2-'+idx">
                                </template>
                                <template v-if="[29].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                                <template v-if="[28].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                       v-html="form.blocksData[idx].col2 || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="[21,22,23,31].includes(element.type)">
                        <div class="row">
                            <div class="mt-2 mb-2 col-6 upload-document-container">
                                <template v-if="[21].includes(element.type)">
                                    <button @click="uploadTrigger(idx,'document')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'documents', 'document')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <iframe v-if="form.blocksData[idx].format == 'document'" class="iframe-editor"
                                            :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+form.blocksData[idx].document+'?token='+token"
                                            width='100%' height='100%' frameborder='0'></iframe>
                                    <iframe v-if="form.blocksData[idx].format == 'pdf'" class="iframe-editor"
                                            :src="form.blocksData[idx].document+'?token='+token" width='100%'
                                            height='500px' frameborder='0'></iframe>

                                    <input @change="uploadFile($event, idx, false, 'document')" type="file"
                                           accept=".pdf,.doc,.docx,.pptx,.pptm,.xlsx,.xls" style="display:none" name=""
                                           :id="'file-input-'+unique+'-document-'+idx">
                                </template>
                                <template v-if="[23,31].includes(element.type)">
                                    <button @click="uploadTrigger(idx,'document1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'documents', 'document1')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <iframe v-if="form.blocksData[idx].format1 == 'document'" class="iframe-editor"
                                            :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+form.blocksData[idx].document1+'?token='+token"
                                            width='100%' height='100%' frameborder='0'></iframe>
                                    <iframe v-if="form.blocksData[idx].format1 == 'pdf'" class="iframe-editor"
                                            :src="form.blocksData[idx].document1+'?token='+token" width='100%'
                                            height='500px' frameborder='0'></iframe>

                                    <input @change="uploadFile($event, idx, 1, 'document')" type="file"
                                           accept=".pdf,.doc,.docx,.pptx,.pptm,.xlsx,.xls" style="display:none" name=""
                                           :id="'file-input-'+unique+'-document1-'+idx">
                                </template>
                                <template v-if="[22].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                                <template v-if="[31].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col1" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col1}"
                                       v-html="form.blocksData[idx].col1 || placeholder"></p>
                                </template>
                            </div>
                            <div class="mt-2 mb-2 col-6 upload-document-container">
                                <template v-if="[22].includes(element.type)">
                                    <button @click="uploadTrigger(idx,'document')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'documents', 'document')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <iframe v-if="form.blocksData[idx].format == 'document'" class="iframe-editor"
                                            :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+form.blocksData[idx].document+'?token='+token"
                                            width='100%' height='100%' frameborder='0'></iframe>
                                    <iframe v-if="form.blocksData[idx].format == 'pdf'" class="iframe-editor"
                                            :src="form.blocksData[idx].document+'?token='+token" width='100%'
                                            height='500px' frameborder='0'></iframe>

                                    <input @change="uploadFile($event, idx, false, 'document')" type="file"
                                           accept=".pdf,.doc,.docx,.pptx,.pptm,.xlsx,.xls" style="display:none" name=""
                                           :id="'file-input-'+unique+'-document-'+idx">
                                </template>
                                <template v-if="[23,31].includes(element.type)">
                                    <button @click="uploadTrigger(idx,'document2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_upload_from_pc') }}
                                    </button>
                                    <button @click="choseFromLibrary(idx, 'documents', 'document2')" type="button"
                                            class="image-upload-editor mt-2 mb-2">
                                        <i class="fas fa-upload"></i>
                                        {{ trans('course.add_course_chose_from_library') }}
                                    </button>
                                    <iframe v-if="form.blocksData[idx].format2 == 'document'" class="iframe-editor"
                                            :src="'https://view.officeapps.live.com/op/embed.aspx?src='+url+form.blocksData[idx].document2+'?token='+token"
                                            width='100%' height='100%' frameborder='0'></iframe>
                                    <iframe v-if="form.blocksData[idx].format2 == 'pdf'" class="iframe-editor"
                                            :src="form.blocksData[idx].document2+'?token='+token" width='100%'
                                            height='500px' frameborder='0'></iframe>

                                    <input @change="uploadFile($event, idx, 2, 'document')" type="file"
                                           accept=".pdf,.doc,.docx,.pptx,.pptm,.xlsx,.xls" style="display:none" name=""
                                           :id="'file-input-'+unique+'-document2-'+idx">
                                </template>
                                <template v-if="[21].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                                <template v-if="[31].includes(element.type)">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].col2" @blur="onEditorBlur" :editor="editor"
                                              :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].col2}"
                                       v-html="form.blocksData[idx].col2 || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                    <template v-if="[24,25].includes(element.type)">
                        <div class="row">
                            <div class="mt-2 mb-2 col-6 upload-document-container">
                                <template v-if="element.type == 24">
                                    <img @click="keepClick(form.blocksData, idx)" data-toggle="tooltip"
                                         data-placement="top" title="Keep" class="pointer keep-image next-link mt-4"
                                         :src="'/images/KeeP Button.png'">
                                </template>
                                <template v-if="element.type == 25">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                            </div>
                            <div class="mt-2 mb-2 col-6 upload-document-container">
                                <template v-if="element.type == 25">
                                    <img @click="keepClick(form.blocksData, idx)" data-toggle="tooltip"
                                         data-placement="top" title="Keep" class="pointer keep-image next-link mt-4"
                                         :src="'/images/KeeP Button.png'">
                                </template>
                                <template v-if="element.type == 24">
                                    <null-safe-ck-editor @ready="onEditorReady" @focus="onEditorFocus"
                                              v-if="form.blocksData[idx].showEditorBlock"
                                              v-model="form.blocksData[idx].content" @blur="onEditorBlur"
                                              :editor="editor" :config="textEditorConfig"></null-safe-ck-editor>
                                    <p @click="showEditorBlock(idx)" v-else class="ck-content ck-content-preview"
                                       :class="{ 'ck-custom-placeholder' : !form.blocksData[idx].content}"
                                       v-html="form.blocksData[idx].content || placeholder"></p>
                                </template>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </draggable>
        <button v-if="type == 'lesson' && form.blocksData.length>2" @click="goToTop" type="button"
                class="btn course-editor-go-top-button">
            <i class="fas fa-level-up-alt"></i>
            {{ trans('course.add_course_go_top') }}
        </button>
        <div class="modal fade libraryModal" :id="'libraryModal'+unique" tabindex="-1" role="dialog"
             aria-labelledby="libraryModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'libraryModalTitle'+unique">
                            {{ trans('course.add_course_library') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12 form-inline w-100 mb-3 justify-content-between">
                                <div class="mr-4">
                                    <label class="justify-content-start"
                                           for="entries">{{ trans('course.add_course_library_filter_by_name') }}</label>
                                    <select @change="filterLibrary('name')" v-model="filterName" class="form-control"
                                            id="name" name="name">
                                        <option value="">{{ trans('course.add_course_library_select_option') }}</option>
                                        <option value="asc">{{ trans('course.add_course_library_ascending') }}</option>
                                        <option value="desc">{{ trans('course.add_course_library_descending') }}
                                        </option>
                                    </select>
                                </div>
                                <div>
                                    <label class="justify-content-start" for="entries">Filter by Size</label>
                                    <select @change="filterLibrary('size')" class="form-control" id="size"
                                            v-model="filterSize">
                                        <option value="">{{ trans('course.add_course_library_select_option') }}</option>
                                        <option value="asc">{{ trans('course.add_course_library_ascending') }}</option>
                                        <option value="desc">{{ trans('course.add_course_library_descending') }}
                                        </option>
                                    </select>
                                </div>
                                <div class="ml-auto pt-3">
                                    <input @input="searchLibrary()" class="form-control mr-sm-2" type="search"
                                           v-model="filterSearch" value="" :placeholder="trans('forms.search')"
                                           aria-label="Search by filename">
                                    <button @click="filterLibrary('search')"
                                            class="btn btn-outline-success my-2 my-sm-0" type="button">
                                        {{ trans('course.add_course_library_search') }}
                                    </button>
                                </div>
                                <!--  <input type="hidden" name="view" value="{{$view}}">
                                 <input type="hidden" name="user" value="{{$userFilter}}"> -->
                            </div>
                            <div v-if="typeof library[0] != 'undefined'" class="col-12 col-sm-6 col-lg-6 col-xl-4" v-for="file in library">
                                <div class="card mb-3 pointer" @click="selectFile(file)">
                                    <!--  <a href="{{route('delete-file-library', ['file' => $file->id,'type' => $type, 'user'=>$userFilter])}}" class="library-delete delete-confirm">
                                         <i class="far fa-trash-alt"></i>
                                     </a> -->
                                    <img v-if="file.type=='images'" class="card-img-top img-fluid img-library" :src="'/library/file/'+file.hash+'?token='
                            +token" alt="Card image cap">
                                    <div v-if="file.type=='videos'" class="pointer text-center preview-file">
                                        <i class="fas fa-film library-icon"></i>
                                    </div>
                                    <div v-if="file.type=='audio'" class="pointer text-center preview-file">
                                        <i class="fas fa-file-audio"></i>
                                    </div>
                                    <div v-if="file.type=='documents'" class="pointer text-center preview-file">
                                        <i class="far fa-file"></i>
                                    </div>

                                </div>
                                <div class="card-body mt-0">
                                    <label class="card-title">
                                        {{ file.path|fileNameFromUrl }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-12 text-center" v-if="showLoadMore">
                                <button type="button"
                                        @click='choseFromLibrary(libraryIdx, libraryType, currentLibraryColumn, libraryPage)'
                                        class="btn btn-primary">{{ trans('course.add_course_library_load_more') }}
                                </button>
                            </div>
                            <div v-if="typeof library[0] == 'undefined'" class=" col-12 text-center mt-4 w-100">
                                <h3>{{ trans('course.add_course_library_search') }}</h3>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            {{ trans('course.add_course_library_close_modal') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="showKeepModal">
            <div class="modal fade in" id="keepModal" tabindex="-1" role="dialog" aria-labelledby="keepModalLabel"
                 aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header">

                            <h5 class="modal-title" id="keepModalLabel">{{ trans('messages.keep.title') }}</h5>
                            <button type="button" class="close" @click="closeModal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <nav v-if="sections" class="nav nav-pills nav-justified">
                                <a @click="curentKeepTab=1" class="nav-item nav-link pointer"
                                   :class="{ active: curentKeepTab==1 }">{{ trans('course.add_course_keep') }}</a>
                                <a @click="getAllKeep()" class="nav-item nav-link pointer"
                                   :class="{ active: curentKeepTab==2}">{{ trans('course.add_course_all_keep') }}</a>
                            </nav>
                            <div class="row mt-3">
                                <div class="col-12">
                                    <template v-if="curentKeepTab == 1">
                                        <!--   <null-safe-ck-editor @ready="insertEditorToolbar":editor="editor" v-model="currentKeep" :config="editorConfig"></null-safe-ck-editor> -->
                                        <html-textarea rows="10" v-model="currentKeep" :key="modalKey"
                                                       class="custom-textarea"
                                        ></html-textarea>
                                    </template>
                                    <template v-else>
                                        <template v-for="(section, ids) in keepSections">
                                            <!--                                            <div>-->
                                            <!--                                                <h5 :class="'type-'+section.type">{{section.name}}</h5>-->
                                            <!--                                            </div>-->

                                            <div class="keep-content-block"
                                                 :class="'type-' + section.type + ' parent-type-' + keepSectionParents[ids]"
                                                 style="color: unset;">
                                                <h5 class="keep-box-title"
                                                    :class="{'kbt-chapter' : !['quiz','lesson'].includes(section.type)}"
                                                >{{ section.name ? section.name : trans('messages.course_creator_default_child_title') }}</h5>
                                                <div v-if="[15,24,25].includes(content.content.type)"
                                                     v-for="(content, idk) in section.content" class="position-relative">
                                                    <div class="keep-tree position-relative" v-if="!content.showEditor">
                                                        <div class="d-inline-block" v-html="content.content.keep"></div>
                                                        <div @click="content.showEditor  = !content.showEditor"
                                                             class=" hover-image content-icon-wrap pos-abs">
                                                            <img :src="'/images/marlms-edit-grey.png'" loading="lazy"
                                                                 alt="" class="inactive-icon" style="opacity: 1;">
                                                            <img :src="'/images/marlms-edit-orange.png'" loading="lazy"
                                                                 style="opacity: 0;" alt="" class="active-icon">
                                                        </div>
                                                    </div>
                                                    <div v-if="content.showEditor" class="mb-3 keep-textarea" :id="'keep_'+ids+'_'+idk">
                                                        <!--    <null-safe-ck-editor @ready="insertEditorToolbar" @blur="saveKeepAll(content, idk)" :editor="editor" v-model="content.content.keep" :config="editorConfig"></null-safe-ck-editor> -->
                                                        <html-textarea @input="saveKeepContent(content.content.keep, idk, section, ids)"
                                                                       v-model="content.content.keep"
                                                                       :scroll-into-view="content.showEditor"
                                                                       class="custom-textarea"></html-textarea>
                                                        <img @click="hideKeepEditor(section,content, ids)"
                                                             :src="'/images/marlms-edit-orange.png'" loading="lazy"
                                                             alt=""
                                                             class="active-icon icon-keep-edit">
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <!--   <template v-for="keepData in keepLessons.keepData" v-if="keepData.content.type == '15'">
                                              <div>
                                                  <div class="d-inline-block"  v-html="keepData.content.keep"></div>
                                                  <a class="pointer" @click="keepData.showEditor  = !keepData.showEditor">
                                                      <i class="fas fa-edit"></i>
                                                  </a>
                                                  <div v-if="keepData.showEditor" class="mb-3">
                                                      <null-safe-ck-editor @ready="insertEditorToolbar" @blur="saveKeepAll(keepData)" :editor="editor" v-model="keepData.content.keep" :config="editorConfig"></null-safe-ck-editor>
                                                  </div>
                                              </div>
                                          </template> -->

                                    </template>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer custom-modal-footer">
                            <button type="button" class="btn btn-secondary" @click="closeModal">
                                {{ trans('course.add_course_close_keep') }}
                            </button>
                            <button v-if="curentKeepTab == 1" type="button" @click="saveKeep" class="btn btn-primary">
                                {{ trans('course.add_course_save_keep') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
// import draggable from "vuedraggable";
// import nestedDraggable from './../FormBuilder/NestedDraggable'
import {CustomEditorNoMediaEmbed} from "@/includes/ck-editor/ck-editor-custom";
import {Cropper, Preview} from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css';
import UploadAdapter from "../UploadAdapter";

export default {
    name: "course-quiz-part",
    components: {
        Cropper, Preview
    },
    created() {
        this.getBlocks();
    },
    props: {
        /*  key: Number,*/
        lid: Number,
        sections: Array,
        cid: Number,
        sid: Number,
        question: Object,
        quizId: Number,
        quizContent: String | Array,
        keep: String,
        type: String,
    },
    computed: {
        keepSectionParents() {
            let lastLevelDepth = 0;
            let keepSectionParents = [];
            this.keepSections.forEach(function ($section, index) {
                if (!['lesson', 'quiz'].includes($section.type)) {
                    keepSectionParents[index] = $section.type - 1;
                    lastLevelDepth = $section.type;
                } else {
                    keepSectionParents[index] = lastLevelDepth;
                }
            })
            return keepSectionParents;
        }
    },
    watch: {
        // blocksChanged() {
        //     this.removeUnneededToolbars();
        // }
    },
    data: function () {
        return {
            url: window.location.protocol + "//" + window.location.host,
            unique: Math.floor(Math.random() * (1500000000 + 1)),
            token: null,
            loader: false,
            blocks: [],
            modalKey: 1,
            currentLibraryId: null,
            currentLibraryColumn: null,
            library: [],
            lesson: [],
            currentKeep: '',
            currentKeepId: null,
            curentKeepTab: 1,
            allKeep: [],
            keepSections: [],
            showKeepModal: false,

            /*this is used for library filters*/
            libraryPage: 1,
            libraryIdx: null,
            libraryType: '',
            libraryCol: '',
            filterName: '',
            filterSize: '',
            filterSearch: '',
            showLoadMore: true,

            form: {
                blockTab: 1,
                blocksData: [],
                lesson: this.lesson ? this.lesson : null,
                section: typeof this.sid != 'undefined' ? this.sections[this.sid] : null,
                type: this.type,
                parentId: null,
                qid: null,
            },
            placeholder: '<p>' + window.trans.course.editor.text_placeholder + '</p>',
            editor: CustomEditorNoMediaEmbed,
            // editorConfig: {
            //     language: document.documentElement.lang,
            //     startupFocus: true,
            //     extraPlugins: [this.editorUploader],
            //     plugins: [
            //         // SourceEditing,
            //     ],
            //     // toolbar: [ 'sourceEditing' ]
            //     removePlugins: [
            //         // 'imageUpload',
            //         'mediaEmbed'
            //     ],
            //     link: {
            //         addTargetToExternalLinks: true,
            //         defaultProtocol: 'http://',
            //     },
            //     toolbar: {
            //         removeItems: [
            //             // 'uploadImage',
            //             'mediaEmbed'
            //         ]
            //     },
            // },
            textEditorConfig: {
                placeholder: window.trans.course.editor.text_placeholder,
                language: document.documentElement.lang,
                removePlugins: [
                    'imageUpload',
                    'mediaEmbed'
                ],
                extraPlugins: [this.editorUploader],
                link: {
                    addTargetToExternalLinks: true,
                    defaultProtocol: 'http://',
                },
                toolbar: {
                    items: [
                        'heading',
                        'style',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        'strikethrough',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'fontColor',
                        // 'highlight',
                        '|',
                        'outdent',
                        'indent',
                        '|',
                        'imageInsert',
                        'blockQuote',
                        'insertTable',
                        'uploadImage',
                        '|',
                        // 'iframeEmbed',
                        'htmlEmbed',
                        'codeBlock',
                        '|',
                        'findAndReplace',
                        'horizontalLine',
                        '|',
                        'undo',
                        'redo',
                        '|',
                        'sourceEditing'
                    ]
                },
                // toolbar: {
                //     removeItems: [
                //         // 'uploadImage',
                //         'mediaEmbed'
                //     ]
                // },
                style: {
                    definitions: [
                        {
                            name: "Memo Box",
                            element: "p",
                            classes: ["memo-box"]
                        },
                        {
                            name: "Info box",
                            element: "p",
                            classes: ["info-box"]
                        },
                        {
                            name: "Spoiler",
                            element: "span",
                            classes: ["spoiler"]
                        },
                    ],
                },
            },
            changesForEmit: [],
            updatingKeepContentAjax: null,
        }
    },
    mounted() {
        this.parseContent();
    },
    methods: {
        editorUploader(editor) {
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                return new UploadAdapter( loader );
            };
        },
        parseContent(sid = false) {
            let $end = '/api/get-lesson/' + this.lid;
            let self = this;
            let blocksData;

            if (this.type == 'lesson') {
                axios.get($end).then(function (res) {
                    self.form.lesson = res.data;
                    self.lesson = res.data;

                    let lessonData = res.data;

                    blocksData = JSON.parse(lessonData.content);
                    self.form.parentId = self.lesson.id;

                    blocksData = blocksData ? blocksData : [];

                    // let deleteContent = false;
                    blocksData.forEach(function (block, id) {
                        blocksData[id].showEditorBlock = false;
                        // if (typeof block.deleted != 'undefined' && block.deleted) {
                        //     deleteContent = true;
                        //     blocksData.splice(id, 1);
                        // } else {
                        //     blocksData[id].showEditorBlock = false;
                        // }
                    });

                    self.form.blocksData = blocksData;


                }).catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
            } else {
                let isSection = this.type == 'description' ? true : false;
                blocksData = isSection ? self.sections[this.sid].descriptionBlocks : (!self.sections ? self.quizContent : self.sections[this.sid].content);
                // console.log(blocksData);
                blocksData = !self.sections ? blocksData : JSON.parse(blocksData);
                self.form.parentId = isSection ? self.sid : self.quizId;

                if (!isSection) {
                    self.form.qid = self.quizId;
                }

                if (isSection && !self.form.section && !this.type == 'question') {
                    self.form.section = self.sections[self.form.parentId];
                }

                blocksData = blocksData ? blocksData : [];

                // let deleteContent = false;
                blocksData.forEach(function (block, id) {
                    blocksData[id].showEditorBlock = false;
                    // if (typeof block.deleted != 'undefined' && block.deleted) {
                    //     deleteContent = true;
                    //     blocksData.splice(id, 1);
                    // } else {
                    //     blocksData[id].showEditorBlock = false;
                    // }
                });

                self.form.blocksData = blocksData;
                // if (deleteContent){
                //     self.change();
                // }
            }

            this.refreshKeepSections();
        },
        refreshKeepSections() {
            let self = this;
            if (this.sections) {
                this.keepSections = [];
                this.sections.forEach(function (section, ids) {
                    let data = {
                        id: section.id,
                        name: section.name,
                        type: section.type,
                        content: [],
                    }

                    let parsableContent;


                    if (['lesson', 'quiz'].includes(section.type)) {
                        parsableContent = section.content ?? '';
                    } else {
                        parsableContent = section.descriptionBlocks;
                    }

                    if (parsableContent) {
                        JSON.parse(parsableContent).forEach(function (keep, idx) {
                            let dataKeep = {
                                lid: section.id, //keep container id
                                ltype: section.type, //keep container type
                                id: idx,
                                content: keep.keep ? keep : {...keep, keep: ''},
                                showEditor: false,
                                sid: ids
                            }
                            data.content.push(dataKeep);
                        });
                    }
                    self.keepSections.push(data);

                    // if (deleteContent){
                    //     self.change();
                    // }

                });
            }
        },
        cloneBlock({id, name, content}) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50)
            let data = {
                id: 0,
                error: false,
                name: name,
                content: content,
                type: id,
            }
            if ([3, 4, 17, 27, 28, 31].includes(id)) {
                data.col1 = content;
                data.col2 = content;
            }
            if (id == 4) {
                data.col3 = content;
            }
            if ([5, 7, 8, 26].includes(id)) {
                data.image = '/images/content-preview.jpg';
                data.originalImage = '';
                data.rezize = false;
                data.clickedBlock = null;
            }
            if ([6, 27].includes(id)) {
                data.image1 = '/images/content-preview.jpg';
                data.image2 = '/images/content-preview.jpg';
                data.col1 = content;
                data.col2 = content;
                data.originalImage1 = '';
                data.originalImage2 = '';
                data.rezize1 = false;
                data.rezize1 = false;

                data.clickedBlock1 = null;
                data.clickedBlock2 = null;
            }
            if ([9, 10, 11, 12].includes(id)) {
                data.video = '/video/preview.mp4?v=' + Math.random();
                data.externalVideo = null;
                data.externalVideoUrl = null;
                data.showExternalVideo = false;
                data.showExternalVideoInput = false;
            }
            if ([16, 17].includes(id)) {
                data.video1 = '/video/preview.mp4?v=' + Math.random();
                data.video2 = '/video/preview.mp4?v=' + Math.random();
                data.showExternalVideo1 = null;
                data.showExternalVideo2 = null;
                data.externalVideo1 = null;
                data.externalVideo2 = null;
                data.externalVideoUrl1 = null;
                data.externalVideoUrl2 = null;
                data.showExternalVideoInput1 = false;
                data.showExternalVideoInput2 = false;
            }
            if ([14, 20, 21, 22, 23, 31].includes(id)) {
                data.format = 'pdf';
                data.format1 = 'pdf';
                data.format2 = 'pdf';
                data.document = '/documents/lorem-ipsum.pdf';
                data.document1 = '/documents/lorem-ipsum.pdf';
                data.document2 = '/documents/lorem-ipsum.pdf';
            }

            if (id == 15) {
                data.keep = null;
                /*  this.saveKeep();*/
                // setTimeout(function(){ self.keepClick(); }, 1400);

            }
            if ([13, 18, 19, 28, 29, 30].includes(id)) {
                data.audio = '/audio/audio.mp3?v=' + Math.random();
                data.audio1 = '/audio/audio.mp3?v=' + Math.random();
                data.audio2 = '/audio/audio.mp3?v=' + Math.random();
            }
            return data;
        },
        getBlocks: function () {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            let $end = '/api/get-blocks';
            let self = this;
            axios.get($end).then(function (res) {
                let response = res.data;
                response.blocks.forEach(function (block) {
                    let data = {
                        id: 0,
                        name: block.name,
                        content: block.content,
                        type: block.id,
                        showEditorBlock: false,
                    }
                    self.blocks.push(data);
                });

                self.blocks = response.blocks;
                self.token = response.token;
                setTimeout(function () {
                    $('[data-toggle="tooltip"]').tooltip();
                }, 100);
            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        change: function (e, loader = false) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip("hide");
            }, 50);
            let $end = '/api/save-editor-blocks';
            let self = this;

            axios.post($end, self.form).then(response => {
                self.loader = false;
                self.$emit('description-method', self.form)
                self.$emit('update-content', self.form)
                self.$forceUpdate();
            }).catch(err => {
                self.$data.loader = false;
            });

        },
        removeBlock(id, event) {
            this.$swal.fire({
                title: event.currentTarget.getAttribute('data-confirm-title'),
                icon: 'warning',
                html: event.currentTarget.getAttribute('data-confirm-message'),
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: window.trans.messages.Yes,
                cancelButtonText: window.trans.messages.No,
                reverseButtons: true,
                focusConfirm: false,
            }).then((result) => {
                if (result.value) {
                    this.form.blocksData[id].deleted = true;
                    //this.form.blocksData.splice(id, 1);
                    this.change();
                }
            });
        },
        restoreBlock(idx, type) {
            this.form.blocksData[idx].deleted = false;
            this.change();
        },
        deletePermanently(idx) {
            this.form.blocksData.splice(idx, 1);
            this.change();
        },
        changeAudio(idx, type) {
            this.form.blocksData[idx].blockType = type;
        },
        uploadTrigger(id, type = false) {
            if (type) {
                id = type + '-' + id;
            }
            $('#file-input-' + this.unique + '-' + id).trigger('click');
        },
        showResizeImage(id, type) {
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip();
            }, 100);
            let originalImage = 'originalImage';
            let image = 'image';
            let resize = 'resize';

            if (type) {
                image = 'image' + type;
                resize = 'resize' + type;
                originalImage = 'originalImage' + type;
            }

            this.form.blocksData[id][originalImage] = this.form.blocksData[id][image];
            this.form.blocksData[id][resize] = true;
            this.$forceUpdate();
        },
        imageZoom(idx, zoom, type = false) {
            let zoomType = zoom == 'minus' ? 0.5 : 2
            let refName = 'cropper' + idx;
            if (type) {
                refName = 'cropper-image' + type + '-' + idx;
            }
            this.$refs[refName][0].zoom(zoomType);
        },
        getOriginalImage(id, type = false) {
            let originalImage = 'originalImage';
            let image = 'image';
            let resize = 'resize';

            if (type) {
                image = 'image' + type;
                resize = 'resize' + type;
                originalImage = 'originalImage' + type;
            }
            this.form.blocksData[id][image] = this.form.blocksData[id][originalImage];
            this.form.blocksData[id][resize] = false;
            this.change();
        },
        showExternalVideo(id, type) {
            this.form.blocksData[id][type] = true;
        },
        addExternalVideo(id, type = false) {
            let typeData1 = 'externalVideo';
            let typeData2 = 'showExternalVideoInput';
            let url = 'externalVideoUrl';
            if (type) {
                typeData1 = typeData1 + type;
                typeData2 = typeData2 + type;
                url = url + type;
            }

            // make sure to deal with YT shorts url
            if (this.form.blocksData[id][url].match(/\/shorts\//)) {
                this.form.blocksData[id][url] = this.form.blocksData[id][url].replace(/\/shorts\//, '/embed/');
            }

            if (!this.validateVideoUrl(id, this.form.blocksData[id][url])) {
                return;
            }
            this.form.blocksData[id][typeData1] = 1;
            this.form.blocksData[id][typeData2] = false;
            this.change();
        },
        uploadFile(e, id, col = false, type) {
            const file = e.target.files[0];
            let extension = file.type;
            let format;

            let column = col ? 'image' + col : 'image';
            if (type == 'video') {
                column = col ? 'video' + col : 'video';
            }
            if (type == 'audio') {
                column = col ? 'audio' + col : 'audio';
            }
            if (type == 'document') {
                column = col ? 'document' + col : 'document';
                format = col ? 'format' + col : 'format';
            }
            let $end = '/api/upload-editor-image';
            let data = new FormData();
            data.append('file', e.target.files[0]);
            data.append('type', type);

            axios.post($end, data).then(response => {
                this.loader = false;


                this.form.blocksData[id][type] = response.data.url;
                if (type == 'image') {
                    this.form.blocksData[id][column] = '/library/file/' + response.data.url;
                }
                if (type == 'video') {
                    this.form.blocksData[id][column] = '/library/file/' + response.data.url;
                    this.form.blocksData[id].externalVideo = 0;
                }
                if (type == 'audio') {
                    this.form.blocksData[id][column] = '/library/file/' + response.data.url;
                }
                if (type == 'document') {
                    this.form.blocksData[id][column] = '/library/file/' + response.data.url;
                    this.form.blocksData[id][format] = 'document';

                    if (extension == 'application/pdf') {
                        this.form.blocksData[id][format] = 'pdf';
                    }
                }
                this.form.blocksData[id].error = null;
                this.change();
            }).catch(err => {
                let errors = err.response.data.errors;
                if (typeof errors != 'undefined') {
                    for (let field of Object.keys(errors)) {
                        this.form.blocksData[id].error = errors[field][0];
                    }
                }
                this.$data.loader = false;
            });
        },
        uploadImage(idx, type = false) {
            let $end = '/api/upload-editor-image';
            let originalImage = 'originalImage';
            let refName = 'cropper' + idx;
            let image = 'image';
            let resize = 'resize';

            if (type) {
                image = 'image' + type;
                resize = 'resize' + type;
                originalImage = 'originalImage' + type;
                refName = 'cropper-image' + type + '-' + idx;
            }

            this.form.blocksData[idx][originalImage] = this.form.blocksData[idx][image];

            const {canvas} = this.$refs[refName][0].getResult();
            if (canvas) {
                const form = new FormData();
                canvas.toBlob(blob => {
                    form.append('file', blob);
                    form.append('type', 'image');
                    form.append("cropped", true);
                    // You can use axios, superagent and other libraries instead here
                    axios.post($end, form).then(response => {
                        this.loader = false;

                        this.form.blocksData[idx][image] = '/library/file/' + response.data.url;
                        this.form.blocksData[idx][resize] = false;
                        this.change();
                    }).catch(err => {
                        this.$data.loader = false;
                    });
                    // Perhaps you should add the setting appropriate file format here
                }, 'image/png');
            }
        },
        changeTab(id) {
            this.form.blockTab = id;
        },
        showEditorBlock(id) {
            this.form.blocksData[id].showEditorBlock = true;
            this.$forceUpdate();
        },
        onEditorReady(editor) {
            editor.editing.view.focus();
        },
        onEditorFocus(event, editor) {
            this.insertEditorToolbar(editor);
        },
        onEditorBlur(event, editor) {
            this.change();
        },
        insertEditorToolbar(editor) {
            editor.ui.focusTracker.on( 'change:isFocused', ( evt, name, isFocused ) => {
                if ( !isFocused && !editor.ui.view.element.contains(document.activeElement)) {
                    this.removeEditorToolbar(editor);
                    editor.ui.focusTracker.off( 'change:isFocused');
                }
            } );

            let container = $(editor.ui.getEditableElement()).parents('.row:first');
            let toolbarContainer = document.createElement('div');
            $(toolbarContainer).addClass('col-12 p-0 editor-toolbar ck ck-editor__top ck-reset_all').html(editor.ui.view.toolbar.element)
            let toolbarWrapper = container[0].querySelector('.sticky-col-editor-toolbar');
            if (!toolbarWrapper) {
                toolbarWrapper = document.createElement('div');
                $(toolbarWrapper).addClass('sticky-col-editor-toolbar')
            }

            $(toolbarWrapper).html(toolbarContainer)
            container.prepend(toolbarWrapper);
        },
        removeEditorToolbar(editor) {
            const container = $(editor.ui.getEditableElement()).parents('.row:first')[0];
            if (container.contains(editor.ui.view.toolbar.element)) {
                $(container).find(editor.ui.view.toolbar.element)[0].remove();
            }
        },
        closeEvent: function () {
            this.clickedBlock = null;
        },
        showEvent: function (idx) {
            this.clickedBlock = idx;
            this.form.blocksData[idx].showInside = true;
            this.$forceUpdate();
            setTimeout(function () {
                $('[data-toggle="tooltip"]').tooltip();
            }, 100);
        },
        keepClick: function (element, id) {
            let self = this;
            // console.log(element[id].keep);
            this.refreshKeepSections();
            this.showKeepModal = true;

            this.currentKeep = element[id].keep ? element[id].keep : '';
            this.currentKeepId = id;
            this.modalKey = this.modalKey + 1;
            // this.$forceUpdate();
            setTimeout(function () {
                $('#keepModal').modal('show');
            }, 100);
        },
        saveKeep: function () {
            // let self = this;
            // this.form.blocksData[this.currentKeepId].keep = this.currentKeep;
            // this.change();
            //
            setTimeout(() => {
                this.closeModal();
            }, 100);
            this.saveKeepContent(this.currentKeep, this.currentKeepId, !this.sections
                ? {
                    id: this.quizId,
                    type: 'quiz'
                } //fake section object for quiz editor
                : this.sections[this.sid], this.sid);
        },
        saveKeepContent(content, blockIndex, section, sectionIndex ) {
            let $end = '/api/update-keep-content';
            this.updatingKeepContentAjax = axios.post($end, {sectionId: section.id, sectionType:section.type.toString(), blockIndex: blockIndex, keep: content, fromQuizEditor: !this.sections}).then(response => {
                this.changesForEmit.push({section: response.data, sectionType:section.type});

                //keepSections and sections arrays have same indexes
                //(so we can use index from one to reference corresponding id from the other
                if (section.type === 'lesson') {
                    this.sections[sectionIndex].content = response.data.content;
                } else if (section.type === 'quiz') {
                    // console.log(this.sections[sectionIndex])
                    // console.log(response.data)
                    if (this.sections) { // this is not a call from quiz editor so update the sections array
                        this.sections[sectionIndex].content = response.data.quiz.content;
                    }
                } else{
                    this.sections[sectionIndex].descriptionBlocks = response.data.description_blocks;
                }

                if (!this.sections || (this.sections[this.sid].id === section.id && this.sections[this.sid].type === section.type)) {
                    this.form.blocksData[blockIndex].keep = content;
                    if (this.currentKeepId === blockIndex) {
                        this.currentKeep = content;
                    }
                }

                //if modal is closed, update
                if (!this.showKeepModal) {
                    this.$emit('update-section-content', this.changesForEmit);
                }
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        hideKeepEditor(data, keep, id,) {
            this.keepSections[id].content[keep.id].showEditor = false;
        },
        // saveKeepAll: function (keep, idk) {
        //
        //     console.log(keep)
        //     let $end = '/api/save-default-keep';
        //     let self = this;
        //
        //     keep.course_id = this.cid;
        //
        //     if ((this.currentKeepId == idk) && (keep.sid == this.sid)) {
        //         this.currentKeep = keep.content.keep;
        //     }
        //
        //     axios.post($end, keep).then(response => {
        //     }).catch(err => {
        //         this.$data.loader = false;
        //     });
        //
        // },
        closeModal:function () {
            this.curentKeepTab = 1;
            this.showKeepModal = false;
            $('#keepModal').modal('hide');
            this.$emit('update-section-content', this.changesForEmit);
        },
        choseFromLibrary: function (id, type, column, page = false) {
            let $end = '/api/library/' + type + '/true';
            let self = this;
            self.showLoadMore = true;

            this.libraryIdx = id;
            this.libraryType = type;
            this.libraryCol = column;

            let params = {};
            if (this.filterName) {
                params.name = this.filterName;
            }
            if (this.filterSize) {
                params.size = this.filterSize;
            }
            if (this.filterSearch) {
                params.search = this.filterSearch;
            }

            if (page) {
                params.page = page + 1;
            }

            this.currentLibraryId = id;
            this.currentLibraryColumn = column;
            axios.get($end, {
                params: params
            }).then(function (res) {
                let response = res.data;
                self.libraryPage = response.files.current_page;

                if (self.libraryPage == response.files.last_page) {
                    self.showLoadMore = false;
                }

                if (page) {
                    self.library = [...self.library, ...response.files.data];
                } else {
                    self.library = response.files.data;
                }
                $('#libraryModal' + self.unique).modal('show');

            }).catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
        },
        searchLibrary: function () {
            if (this.filterSearch.length >= 2 || this.filterSearch.length === 0) {
                this.filterLibrary("search")
            }
        },
        filterLibrary: function (type) {
            if (type == 'name') {
                this.filterSize = '';
            }
            if (type == 'size') {
                this.filterName = '';
            }
            this.choseFromLibrary(this.libraryIdx, this.libraryType, this.currentLibraryColumn)
        },
        selectFile: function (file) {
            if (file.type == 'documents') {
                var extension = file.path.split('.').pop();

                let format = this.currentLibraryColumn == 'document' ? 'format' : (this.currentLibraryColumn == 'document1' ? 'format1' : 'format2');
                if (extension == 'pdf') {
                    this.form.blocksData[this.currentLibraryId][format] = 'pdf';
                } else {
                    this.form.blocksData[this.currentLibraryId][format] = 'document';
                }
            }
            if (file.type == 'images') {
                let originalImage = 'originalImage';
                let image = this.form.blocksData[this.currentLibraryId];

                originalImage = 'original' + this.libraryCol.charAt(0).toUpperCase() + this.libraryCol.slice(1);
                this.form.blocksData[this.currentLibraryId][originalImage] = '/library/file/' + file.hash;
            }
            this.form.blocksData[this.currentLibraryId][this.currentLibraryColumn] = '/library/file/' + file.hash;

            this.change();
            $('#libraryModal' + this.unique).modal('hide');
        },
        getAllKeep: function () {
            this.parseContent(this.sid);
            this.curentKeepTab = 2;
            if (typeof this.keepSections[this.sid].content[this.currentKeepId] != 'undefined') {
                this.keepSections[this.sid].content[this.currentKeepId].showEditor = true;
            }
        },
        validateVideoUrl: function (idx, url) {
            var regExpYoutube = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;

            var vimeoRegExp = /(?:https?:\/\/(?:www\.)?)?vimeo.com\/(?:channels\/|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;

            if (!url || (!url.match(regExpYoutube) && !url.match(vimeoRegExp))) {
                this.form.blocksData[idx].error = 'Please add a Youtube or Vimeo link';
                setTimeout(() => {
                    this.form.blocksData[idx].error = null
                }, 5000);
                this.$forceUpdate();
                return false;
            }
            this.form.blocksData[idx].error = null;
            this.$forceUpdate();
            return true;
        },
        goToTop: function () {
            let top = $('#element-lesson-' + this.lesson.id).offset().top - 100;
            window.scrollTo({
                top: top,
                behavior: 'smooth'
            });
        },
        isDefaultImage(image) {
            return image === '/images/content-preview.jpg';
        },
        copyMediaReferenceToClipboard(image) {
            const imageRef = image.split('/').slice(-1)[0];
            navigator.clipboard.writeText(imageRef);
            toastr.success(window.trans.messages.copied_to_clipboard);
        }
    },
}
</script>
<style type="text/css">
.ck-content-preview {
    margin-bottom: 0;
}

.ck-content-preview > :first-child {
    margin-top: var(--ck-spacing-large);
}

.ck-content-preview > :last-child {
    margin-bottom: var(--ck-spacing-large);
}

.ck-content-preview {
    overflow: auto;
    padding: 0 var(--ck-spacing-standard);
    border: 1px solid transparent;
}

.ck-content-preview {
    min-height: 100px !important;
}

.ck-custom-placeholder {
    cursor: text;
    color: var(--ck-color-engine-placeholder-text);
}
</style>
